module.exports = __webpack_public_path__ + "img/ax.fdd00c43.svg";